import { render, staticRenderFns } from "./CompanyLaw.vue?vue&type=template&id=05d0d850&scoped=true&"
import script from "./CompanyLaw.vue?vue&type=script&lang=js&"
export * from "./CompanyLaw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d0d850",
  null
  
)

export default component.exports